import PropTypes from 'prop-types';
import React from 'react';
import Row from '../row/row';
import {get, map} from 'lodash';
import { getModuleAdSizes } from '../../utils/ads/sizes';

const DesktopContentModule = ({
  adsState,
  archivesState,
  breakpoint,
  id,
  page_id,
  page_type,
  rows,
  title,
  type,
  channelCampaignBrandingImage,
  channelSubtitle
}) => (
  <div>
    {
      map(rows, row => (
        <Row {...row}
          key={get(row, 'cards[0].id')}
          adPosition={row[`${breakpoint}AdPosition`]}
          adSizes={getModuleAdSizes(type, breakpoint)}
          adsState={adsState}
          archivesState={archivesState}
          breakpoint={breakpoint}
          moduleID={id}
          moduleTitle={title}
          moduleType={type}
          page_id={page_id}
          page_type={page_type}
          channelCampaignBrandingImage={channelCampaignBrandingImage}
          channelSubtitle={channelSubtitle}
        />
      ))
    }
  </div>
);

DesktopContentModule.propTypes = {
  adsState: PropTypes.object.isRequired,
  archivesState: PropTypes.object,
  breakpoint: PropTypes.string,
  id: PropTypes.number.isRequired,
  page_id: PropTypes.number.isRequired,
  page_type: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    rowID: PropTypes.number,
    indexWithinModule: PropTypes.number,
    moduleTitle: PropTypes.string,
    cards: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number }))
  })).isRequired,
  title: PropTypes.string,
  type: PropTypes.string,
  channelCampaignBrandingImage: PropTypes.string,
  channelSubtitle: PropTypes.string
};

DesktopContentModule.defaultProps = {
  adsState: {},
  rows: []
};

export default DesktopContentModule;
